import axios from 'axios';
import { makeUrl } from '@voomly/utils';
import { IFunnelRaw, IPasswordProtectedFunnelData } from '../../types/funnels';

export type IFunnelPublicResponse = IFunnelRaw | IPasswordProtectedFunnelData;

export const isFunnelPasswordProtected = (
  value: IFunnelPublicResponse
): value is IPasswordProtectedFunnelData => {
  return !!(value as IPasswordProtectedFunnelData)?.player?.security?.enabled;
};

export const getFunnelPublicRequest = (funnelId: string) => {
  return axios.get<IFunnelPublicResponse>(
    makeUrl(`/video-funnels/${funnelId}`)
  );
};

export const getPasswordProtectedFunnelPublicRequest = (
  funnelId: string,
  password: string
) =>
  axios.post<IFunnelRaw>(makeUrl(`/video-funnels/${funnelId}/get`), {
    password,
  });
